<template>
  <div id="login_form">
    <h3 class="mb-4">
      Login
    </h3>
    <form class="kt-form" @submit.prevent="login()">
      <input type="hidden" name="_token" :value="csrf">

      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <div v-if="success">
        <div class="alert alert-success" role="alert">
          {{ success }}
        </div>
      </div>

      <div class="form-group">
        <input id="email" v-model="form.email"
               type="email"
               class="form-control"
               name="email" required
               placeholder="Email Address..."
               autocomplete="email" autofocus>
      </div>

      <div class="form-group">
        <input id="password" v-model="form.password"
               type="password"
               class="form-control"
               name="password" required
               placeholder="Password..."
               autocomplete="current-password">
      </div>

      <div class="form-group">
        <ss-checkbox id="remember" v-model="form.remember">
          Remember Me
        </ss-checkbox>
      </div>

      <div class="form-group mb-0">
        <div class="">
          <button id="submit_login" type="submit" class="btn btn-ss-standout mr-2">
            Login
          </button>

          <a class="kt-link" @click="showForm('forgot_password_form')">
            Forgot your password ?
          </a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthFormsMixin from "VueMixins/AuthFormsMixin";

export default {
  mixins: [AuthFormsMixin],
  data() {
    return {
      reset_token: window.reset_token,
      form: {
        email: null,
        password: null,
        remember: null,
      },
    };
  },
  methods: {
    login() {
      this.laddaButton("submit_login");
      this.form._token = window.csrfToken;
      axios.post(`/login`, this.form).then(() => {
        if (window.redirect_url) {
          this.setSuccess("Redirecting you to Radar.");
          window.location.href = window.redirect_url;
        } else {
          this.setSuccess("Logging you in...");
          this.unLaddaButton("submit_login");

          const target = (() => {
            const from_timbre = window.previous_url.search(window.host) !== -1;
            if (from_timbre) {
              return window.previous_url;
            }

            return '/'; // default to directing to home
          })();

          window.location.href = target;
        }
      }).catch((error) => {
        this.unLaddaButton("submit_login");
        if (error.response.data.new_token) {
          EventBus.$emit('new_token', error.response.data.new_token);
        }

        if (error.response.data.two_factor_required) {
          window.two_factor_required = true;
          window.user_uuid = error.response.data.user_uuid;
          this.setError("Device not authenticated");
          this.showForm('two_factor_form');
          return;
        }

        if (error.response.status === 403 && error.response.data.message.includes('not verified')) {
          this.setError("Email address not verified");
          this.showForm('verify_email_form');
        } else {
          this.setError("Your email or password is incorrect");
        }
      });
    },
  },
};
</script>
